<template>
	<div class="d-flex flex-row align-items-center" style="gap: 7px">
		<div class="p-1 border rounded warning-invoice d-flex align-items-center" :class="{ 'mobile-error-font mb-2': maxMobileScreenWidth }" style="gap: 7px">
			<component :is="getLucideIcon('AlertCircle')" :size="maxMobileScreenWidth ? 16 : 24" :stroke-width="1.5" />
			<span>
				<slot></slot>
			</span>
		</div>
	</div>
</template>

<script>
import globalMixin from '@/mixins/global.mixin';

export default {
	name: 'InvoiceAlert',
	mixins: [globalMixin],
	props: {
		maxMobileScreenWidth: {
			type: Boolean,
			required: false,
			default: false
		}
	}
};
</script>

<style>
.warning-invoice {
	color: #bc9581;
	border-color: #bc9581;
}
</style>
